import { withInstall } from '@vitamin/shared'
import Button from './src/button.vue'

export const VcButton = withInstall(Button)
export default VcButton
